import form from "../Form.module.css";
import { ControlledClickPopover } from "components/ClickPopover";
import * as Menu from "components/MenuPanel/MenuPanel";
import { IconChevronUp } from "components/Icons/IconChevronUp";
import { IconChevronDown } from "components/Icons/IconChevronDown";

import { useState } from "react";

import {
  applyTimeOfDayOptionToCronString,
  toTimeOfDayOption,
  timeOfDayOptions,
  TimeOfDayOption,
} from "../cron/optionsTimeOfDay";
import type { FormState } from "../FormState";
import type { Dispatch, SetStateAction } from "react";

interface Props<FState> {
  state: FState;
  setState: Dispatch<SetStateAction<FState>>;
}

export function FieldTimeOfDay<FState extends FormState>(props: Props<FState>) {
  const { state, setState } = props;

  const selectedOption = toTimeOfDayOption(state.cronString);

  function setSelectedOption(option: TimeOfDayOption) {
    setState((state) => ({
      ...state,
      cronString: applyTimeOfDayOptionToCronString(state.cronString, option),
    }));
  }

  const [isOpen, setIsOpen] = useState(false);

  return (
    <label className={form.label}>
      <span>At this time</span>

      <ControlledClickPopover
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        // TODO: position="below-full-width"
        position="below-align-left"
        content={({ close }) => (
          <Menu.Panel>
            <Menu.Section maxHeight="30.5rem">
              {timeOfDayOptions.map((option) => (
                <Menu.ItemButton
                  key={option.display}
                  selected={option === selectedOption}
                  onClick={() => {
                    setSelectedOption(option);
                    close();
                  }}
                >
                  {option.display}
                </Menu.ItemButton>
              ))}
            </Menu.Section>
          </Menu.Panel>
        )}
      >
        <button type="button">
          <span className={form.fieldText}>
            {selectedOption?.display ?? "Unset"}
          </span>
          {!isOpen ? <IconChevronDown /> : <IconChevronUp />}
        </button>
      </ControlledClickPopover>
    </label>
  );
}
